import AclName from '../AclName.js';

export default [
  // AclName.BookkeepingBtnClosedMonthAdd,
  // AclName.BookkeepingBtnClosedMonthOpenMonth,
  // AclName.BookkeepingBtnClosedMonthRecloseMonth,
  // AclName.BookkeepingBtnClosedMonthSendInformationToTheClient,
  AclName.BookkeepingBtnClosedMonthTaxesInfo,
  AclName.BookkeepingPageClosedMonthTaxesInfo,
  // AclName.BookkeepingBtnDeclarationsCorrectVatDeclaration,
  // AclName.BookkeepingBtnDeclarationsDelete,
  // AclName.BookkeepingBtnDeclarationsDownloadHubsign,
  // AclName.BookkeepingBtnDeclarationsVatAddDeclaration,
  AclName.BookkeepingBtnDeclarationsVatPrint,
  AclName.BookkeepingBtnDeclarationsVatPrintUPO,
  // AclName.BookkeepingBtnDeclarationsVatRefresh,
  // AclName.BookkeepingBtnDeclarationsVatSignAndSend,
  AclName.BookkeepingPageClosedMonthList,
  // AclName.BookkeepingBtnEvidencesAdd,
  // AclName.BookkeepingBtnEvidencesCalculateExchangeRateDifferences,
  // AclName.BookkeepingBtnEvidencesDelete,
  // AclName.BookkeepingBtnEvidencesEdit,
  AclName.BookkeepingBtnEvidencesFiles,
  AclName.BookkeepingBtnEvidencesPreview,
  AclName.BookkeepingBtnEvidencesPrintInternalEvidences,
  // AclName.BookkeepingBtnInvoiceExportToSymfonia,
  AclName.BookkeepingBtnVehiclesAdd,
  // AclName.BookkeepingBtnVehiclesDelete,
  // AclName.BookkeepingBtnVehiclesEdit,

  AclName.BookkeepingPageDeclarationsPitList,
  AclName.BookkeepingPageDeclarationsVatList,

  // AclName.BookkeepingPageEvidencesAdd,
  AclName.BookkeepingPageEvidencesClosedMonthAdd,
  AclName.BookkeepingPageEvidencesClosedMonthList,
  AclName.BookkeepingPageEvidencesEdit,
  AclName.BookkeepingPageEvidencesList,
  AclName.BookkeepingPageEvidencesPrints,
  AclName.BookkeepingPageEvidencesAllList,
  // AclName.BookkeepingPageInvoicesAdd,
  // AclName.BookkeepingPageInvoicesCorrectionAdd,
  // AclName.BookkeepingPageInvoicesCorrectionEdit,
  // AclName.BookkeepingPageInvoicesEdit,
  // AclName.BookkeepingPageInvoicesKlaEdit,
  // AclName.BookkeepingPageInvoicesKlaList,
  // AclName.BookkeepingPageInvoicesList,
  AclName.BookkeepingPageVehiclesAdd,
  // AclName.BookkeepingPageVehiclesEdit,
  AclName.BookkeepingPageVehiclesList,

  // AclName.BookkeepingBtnEvidencesInternalEvidence,

  AclName.BookkeepingPageFixedAssetsList,
  // AclName.BookkeepingPageFixedAssetsAdd,
  // AclName.BookkeepingPageFixedAssetsEdit,

  AclName.CrmPageAgreementReview,

  AclName.BookkeepingEvidencesAccessAll,

  AclName.CrmPageBillingList,
  AclName.CrmPageBillingSettle,
  AclName.CrmPageBankingOperationsList,
  AclName.CrmPageBankingOperationsSettle,
  AclName.CrmPageMailingList,
  AclName.CrmPageMailingStepper,
  AclName.CrmBtnMailingDelete,
  AclName.CrmBtnMailingEdit,
  AclName.CrmBtnMailingSendNow,
  AclName.MailingSettingsBtnSave,
  AclName.MailingAdmin,
];
